<template>
  <BasicLayout>
    <template #wrapper>
      <el-card>
        <div class="salesCard">
          <el-form ref="queryForm" :inline="true">
            <el-form-item label="开始日期">
              <el-date-picker
                v-model="queryParams.startDate"
                placeholder="请选择日期"
                clearable
                value-format="yyyy-MM-dd"
                type="date"
                size="small"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="结束日期">
              <el-date-picker
                v-model="queryParams.endDate"
                placeholder="请选择日期"
                clearable
                value-format="yyyy-MM-dd"
                type="date"
                size="small"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getUserRegAnalyze } from '@/api/statistics/user_remain'
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'IndexUserRegAnalyze',
  data() {
    return {
      chartData: {},
      loading: false,
      chart: {},
      option: {},
      queryParams: {
        startDate: '',
        endDate: ''
      }
    }
  },
  created() {
    this.getTables()
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleKeyUp() {
      this.onSubmit()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }
      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }

      this.getTables()
    },
    getTables() {
      getUserRegAnalyze(this.queryParams).then(res => {
        if (res.code === 200) {
          const data = res.data.data
          const dateArr = []
          const userRegData = []
          const inviteData = []
          const naturallyData = []
          const inviteRateData = []
          const naturallyRateData = []
          for (const i in data) {
            const item = data[i]
            dateArr.push(dateStrTodate(item.date))
            userRegData.push(item.reg_count)
            inviteData.push(item.invite_reg)
            naturallyData.push(item.user_naturally)
            let inviteRate = 0
            let naturaRate = 0
            if (item.reg_count > 0) {
              inviteRate = item.invite_reg / item.reg_count
              inviteRate = (inviteRate * 100).toFixed(2)

              naturaRate = item.user_naturally / item.reg_count
              naturaRate = (naturaRate * 100).toFixed(2)
            }
            inviteRateData.push(inviteRate)
            naturallyRateData.push(naturaRate)
          }
          this.option.xAxis.data = dateArr
          this.option.series[0].data = userRegData
          this.option.series[1].data = inviteData
          this.option.series[2].data = naturallyData
          this.option.series[3].data = inviteRateData
          this.option.series[4].data = naturallyRateData
          this.queryParams.startDate = res.data.req.startDate
          this.queryParams.endDate = res.data.req.endDate
          this.chart.setOption(this.option, true)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    numFormatter(row, column, cellValue, index) {
      return cellValue + '%'
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        xAxis: {
          data: []
        },
        legend: {
          data: ['注册', '邀请', '自然', '邀请占比', '自然占比']
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: [
          {
            type: 'value',
            name: '人数',
            axisLabel: {
              formatter: '{value} /人'
            }
          },
          {
            type: 'value',
            name: '占比',
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: [
          {
            name: '注册',
            type: 'bar',
            barGap: '-100%',
            data: [],
            itemStyle: {
              normal: {
                color: '#3CB371'
              }
            }
          },
          {
            name: '邀请',
            type: 'bar',
            data: [],
            itemStyle: {
              normal: {
                color: '#FFD700'
              }
            }
          },
          {
            name: '自然',
            type: 'bar',
            data: [],
            itemStyle: {
              normal: {
                color: '#00BFFF'
              }
            }
          },
          {
            name: '邀请占比',
            type: 'line',
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: '#FF0000'
              }
            },
            tooltip: {
              valueFormatter: function(value) {
                return value + ' %'
              }
            },
            data: []
          },
          {
            name: '自然占比',
            type: 'line',
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: '#FA8072'
              }
            },
            tooltip: {
              valueFormatter: function(value) {
                return value + ' %'
              }
            },
            data: []
          }
        ]
      }
      this.chart.setOption(this.option)
    }
  }
}
</script>

<style scoped>
</style>
